var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"img-fluid avatar",style:({width: _vm.width}),attrs:{"src":_vm.avatar}})
}
var staticRenderFns = []

export { render, staticRenderFns }